<template>
  <header class="site-header" :class="{ scrolled: isScrolled }">
    <div class="container header-inner">
      <SiteLogo />

      <nav class="desktop-nav" aria-label="主导航">
        <router-link to="/" class="nav-link" :class="{ active: isActive('/') }">首页</router-link>

        <!-- 产品下拉 -->
        <div class="nav-item has-drop" @mouseenter="proOpen = true" @mouseleave="proOpen = false">
          <button
            class="nav-link drop-trigger"
            :class="{ active: isActive('/product') }"
            :aria-expanded="proOpen"
            @click="togglePro"
          >
            产品
            <svg
              class="chev"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>

          <transition name="drop">
            <div v-if="proOpen" class="nav-drop-panel" @click.stop>
              <div class="nd-head">
                <span>我们的产品</span>
                <small>PRODUCTS</small>
              </div>
              <div class="nd-grid">
                <router-link class="nd-card" to="/product#work-phone" @click="proOpen = false">
                  <div class="nd-body">
                    <b>叮通工作手机</b>
                    <p>考勤审批、员工定位、轨迹回放、沟通留痕</p>
                  </div>
                  <span class="nd-arrow">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </span>
                </router-link>

                <router-link class="nd-card" to="/product#erp" @click="proOpen = false">
                  <div class="nd-body">
                    <b>叮通ERP系统</b>
                    <p>报价、销售、工程、生产、采购、仓储、财务、行政</p>
                  </div>
                  <span class="nd-arrow">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </span>
                </router-link>
              </div>
              <router-link class="nd-foot" to="/product" @click="proOpen = false">
                查看产品中心详情
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </router-link>
            </div>
          </transition>
        </div>

        <router-link to="/about" class="nav-link" :class="{ active: isActive('/about') }">关于我们</router-link>
        <router-link to="/contact" class="nav-link" :class="{ active: isActive('/contact') }">联系我们</router-link>
      </nav>

      <div class="header-actions">
        <a class="phone-link" href="tel:13906000035">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.58 2.81.7A2 2 0 0 1 22 16.92z"
            />
          </svg>
          139 0600 0035
        </a>
        <router-link to="/contact" class="btn btn-sm btn-primary">预约演示</router-link>
        <button class="menu-toggle" :aria-expanded="open" aria-label="菜单" @click="open = !open">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <transition name="drop">
      <nav v-if="open" class="mobile-nav" aria-label="移动端导航">
        <router-link
          v-for="item in navs"
          :key="item.path"
          :to="item.path"
          class="mobile-link"
          @click="open = false"
        >{{ item.label }}</router-link>
        <router-link to="/contact" class="mobile-link accent" @click="open = false">预约演示</router-link>
      </nav>
    </transition>
  </header>
</template>

<script>
import SiteLogo from "./SiteLogo.vue";

export default {
  name: "SiteHeader",
  components: { SiteLogo },
  data() {
    return {
      open: false,
      proOpen: false,
      isScrolled: false,
      navs: [
        { path: "/", label: "首页" },
        { path: "/product", label: "产品中心" },
        { path: "/about", label: "关于我们" },
        { path: "/contact", label: "联系我们" },
      ],
    };
  },
  created() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 8;
    },
    isActive(path) {
      return this.$route.path === path;
    },
    togglePro() {
      this.proOpen = !this.proOpen;
    },
  },
};
</script>

<style scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 60;
  height: var(--header-h);
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.92);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid transparent;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
}
.site-header.scrolled {
  border-bottom-color: var(--c-line);
  box-shadow: 0 6px 24px rgba(10, 47, 138, 0.08);
}
.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.desktop-nav {
  display: flex;
  gap: 6px;
  align-items: center;
}
.nav-link {
  position: relative;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  color: var(--c-ink);
  border-radius: 8px;
  transition: color 0.2s ease;
}
.nav-link::after {
  content: "";
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 2px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #12c2f2, #1453e6);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.25s ease;
}
.nav-link:hover,
.nav-link.active {
  color: var(--c-primary);
}
.nav-link.active::after {
  transform: scaleX(1);
}
/* 下拉触发器 */
.nav-item {
  position: relative;
}
.drop-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: none;
  cursor: pointer;
  font: inherit;
  font-weight: 500;
  font-size: 15px;
  color: var(--c-ink);
}
.drop-trigger .chev {
  width: 15px;
  height: 15px;
  transition: transform 0.25s ease;
}
.nav-item.has-drop:hover .drop-trigger .chev,
.drop-trigger[aria-expanded="true"] .chev {
  transform: rotate(180deg);
}

/* 下拉面板 */
.nav-drop-panel {
  position: absolute;
  top: calc(100% + 14px);
  left: 50%;
  transform: translateX(-50%);
  width: min(560px, 84vw);
  background: #fff;
  border: 1px solid var(--c-line);
  border-radius: 18px;
  box-shadow: 0 30px 70px rgba(10, 47, 138, 0.18);
  padding: 22px;
  cursor: default;
}
.nav-drop-panel::before {
  content: "";
  position: absolute;
  top: -7px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 14px;
  height: 14px;
  background: #fff;
  border-left: 1px solid var(--c-line);
  border-top: 1px solid var(--c-line);
}
.nd-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef2fb;
  margin-bottom: 14px;
}
.nd-head span {
  font-size: 13px;
  font-weight: 700;
  color: var(--c-ink);
}
.nd-head small {
  font-size: 11px;
  letter-spacing: 0.18em;
  color: var(--c-muted);
  text-transform: uppercase;
}
.nd-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.nd-card {
  display: flex;
  gap: 13px;
  padding: 15px;
  border: 1px solid var(--c-line);
  border-radius: 14px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease,
    transform 0.25s ease;
}
.nd-card:hover {
  border-color: var(--c-primary);
  box-shadow: 0 12px 30px rgba(20, 83, 230, 0.14);
  transform: translateY(-2px);
}
.nd-ico {
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.nd-ico svg {
  width: 23px;
  height: 23px;
}
.ico-phone {
  background: linear-gradient(135deg, #1b6cff, #12c2f2);
}
.ico-erp {
  background: linear-gradient(135deg, #7a5af8, #1b6cff);
}
.nd-body {
  min-width: 0;
  flex: 1;
}
.nd-body b {
  display: block;
  font-size: 15px;
  color: var(--c-ink);
}
.nd-body span {
  display: block;
  font-size: 12px;
  color: var(--c-primary);
  margin: 2px 0 6px;
}
.nd-body p {
  margin: 0;
  font-size: 12px;
  color: var(--c-muted);
  line-height: 1.6;
}
.nd-arrow {
  flex: none;
  align-self: center;
  color: #c3d2ee;
  transition: color 0.25s ease, transform 0.25s ease;
}
.nd-arrow svg {
  width: 18px;
  height: 18px;
}
.nd-card:hover .nd-arrow {
  color: var(--c-primary);
  transform: translateX(3px);
}
.nd-foot {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #eef2fb;
  font-size: 13px;
  font-weight: 600;
  color: var(--c-primary);
}
.nd-foot svg {
  width: 16px;
  height: 16px;
}
.nd-foot:hover {
  text-decoration: underline;
}
.drop-enter-active,
.drop-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.drop-enter-from,
.drop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-8px);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.phone-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: var(--c-primary-deep);
}
.phone-link svg {
  width: 15px;
  height: 15px;
}
.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--c-line);
  border-radius: 10px;
  cursor: pointer;
}
.menu-toggle span {
  display: block;
  width: 18px;
  height: 2px;
  margin: 0 auto;
  background: var(--c-ink);
  border-radius: 2px;
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.mobile-nav {
  position: absolute;
  top: var(--header-h);
  left: 12px;
  right: 12px;
  background: #fff;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 20px 50px rgba(10, 47, 138, 0.18);
  border: 1px solid var(--c-line);
}
.mobile-link {
  display: block;
  padding: 13px 16px;
  font-size: 15px;
  font-weight: 500;
  color: var(--c-ink);
  border-radius: 10px;
}
.mobile-link + .mobile-link {
  border-top: 1px solid #f1f4fb;
}
.mobile-link.router-link-exact-active {
  color: var(--c-primary);
  background: #eef4ff;
}
.mobile-link.accent {
  color: var(--c-primary);
  text-align: center;
  font-weight: 600;
}

@media (max-width: 900px) {
  .desktop-nav {
    display: none;
  }
  .phone-link {
    display: none;
  }
  .header-actions .btn {
    display: none;
  }
  .menu-toggle {
    display: flex;
  }
}
</style>
